// extracted by mini-css-extract-plugin
export default {"a0":"xaJfGqpi42EbnnMxuJLJ","a1":"RvF4HmCDEI093JeRDRGP","a2":"RvF4HmCDEI093JeRDRGP","cls1":"muMTCmLicTeSJIUC3PDV","cls2":"OPuu2clOKIp2b0vuUBVk muMTCmLicTeSJIUC3PDV"};